// src/Home.js
import { useEffect, useState } from "react";
import Header from './Header';
import Footer from './Footer';
import FAQ from './FAQ';
import { FaFileAlt, FaScroll, FaBan, FaCheckCircle, FaLightbulb, FaRecycle } from 'react-icons/fa';
import recycleIcon from '../assets/recycle-crop.png';
import plastic from '../assets/plastic.png';
import glass from '../assets/glass.png';
import tin from '../assets/tin.jpg';
import checkmark from '../assets/check-mark.png';
import credit from '../assets/deposit.png';
import partner from '../assets/delivery.png';
import redeem from '../assets/redeem.png';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { TbRecycle } from 'react-icons/tb';
import { RiFileList3Line } from 'react-icons/ri';


function Home() {

   const slogans = [
      '🚖 Your Fare Powers Your Fuel.',
      '♻️ Turn Bottles into Miles.',
      '⛽ From Trash to Tank.',
      '🌆 Green Miles, Cleaner City.',
      '💵 Ride Clean. Earn Rewards.',
      '🔋 Recycling that Fuels the Future.',
      '🧃 Drive the Change, Bottle by Bottle.',
      '💧 Drive. Recycle. Fuel Up.'
   ];

   const [current, setCurrent] = useState(0);
   const [fade, setFade] = useState(true);

   useEffect(() => {
      const interval = setInterval(() => {
         setFade(false);
         setTimeout(() => {
            setCurrent((prev) => (prev + 1) % slogans.length);
            setFade(true);
         }, 300);
      }, 2500);
      return () => clearInterval(interval);
   }, []);

   return (
      <div className="">
         <Header />
         <div className="bg-gray-100 p-6 flex items-center justify-center">
            <div
               className={`text-2xl  font-semibold text-green-800 transition-opacity duration-500 ${fade ? "opacity-100" : "opacity-0"
                  }`}>
               {slogans[current]}
            </div>
         </div>

         <main className="pt-4 pb-20 px-8 bg-gray-100">
            <h2 className="text-3xl font-bold text-center mb-10">
               What Kind of <span className="text-[#9cc026]">Containers</span> We <span className="text-[#9cc026]">Recycle</span>.
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
               {/* Plastic */}
               <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition duration-300">
                  <img src={plastic} alt="Plastic Bottles" className="mx-auto mb-4 h-24" />
                  <h3 className="font-bold text-lg">Plastic C TRV:ME NY</h3>
                  <p className="text-gray-600 mt-2">
                     Most usually used water, juice and soda bottles.
                  </p>
               </div>

               {/* Glass */}
               <div className="bg-[#9cc026] text-white p-6 rounded-lg shadow hover:shadow-lg transition duration-300">
                  <h3 className="font-bold text-lg mb-2">Glass C TRV:ME NY</h3>
                  <img src={glass} alt="Glass Bottles" className="mx-auto mb-4 h-24" />
                  <p>
                     Most usually used beer, soda, wine, liquor and juice bottles.
                  </p>
               </div>

               {/* Cans */}
               <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition duration-300">
                  <img src={tin} alt="Cans" className="mx-auto mb-4 h-24" />
                  <h3 className="font-bold text-lg">Cans C TRV:ME NY</h3>
                  <p className="text-gray-600 mt-2">
                     Most usually this refers to used soda and beer cans.
                  </p>
               </div>
            </div>
         </main>

         <section className="bg-[#ECFFDC] py-10 px-4 md:px-12">
            <div className="text-center mb-8">
               <h2 className="text-3xl font-bold text-center mb-6">
                  Can I Return<span className="text-[#9cc026]"> Out-of-State Beverage Containers</span> in New York?
               </h2>

               <p className="mt-3 text-sm italic text-gray-500 max-w-2xl mx-auto">
                  No — You cannot return out-of-state beverage containers for redeem credit under New York’s Bottle Bill.
               </p>
            </div>

            <div className="max-w-3xl mx-auto space-y-4">

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaFileAlt className="text-[#003679]" /> Why Out-of-State Returns Aren’t Eligible
                     </span>
                  }
                  answer={
                     <>
                        <p className="mb-2">New York law allows retailers and redemption centers to refuse:</p>
                        <ul className="space-y-2">
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Containers that were not sold in New York</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Containers without a valid “NY 5¢” label</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Brands, sizes, or types not sold in New York</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Any container not associated with a NY deposit</span>
                           </li>
                        </ul>
                     </>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaScroll className="text-[#794f00]" /> What the Law Says
                     </span>
                  }
                  answer={
                     <p className="mb-2">
                        Under New York Bottle Bill regulations, only eligible containers with a valid NY deposit label can be returned for redeem credit.
                     </p>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaBan className="text-[#b91c1c]" /> Retailers Have the Right to Refuse
                     </span>
                  }
                  answer={
                     <>
                        <p className="mb-2">
                           Retail outlets and redemption centers can legally refuse beverage containers that:
                        </p>
                        <ul className="space-y-2">
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Are missing the “NY 5¢” label</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Are a different brand, size, or shape than what they sell</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Were purchased out of state</span>
                           </li>
                        </ul>
                     </>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaCheckCircle className="text-green-600" /> Bottom Line — Eligibility
                     </span>
                  }
                  answer={
                     <>
                        <p className="mb-2">To receive redeem credit in New York, your container must:</p>
                        <ul className="space-y-2">
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Be clearly labeled “NY 5¢”</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Be purchased in New York</span>
                           </li>
                           <li className="flex items-start gap-2">
                              <FaRecycle className="text-green-600 mt-1" />
                              <span>Be an eligible beverage container under NY law</span>
                           </li>
                        </ul>
                     </>
                  }
               />

               <FAQ
                  question={
                     <span className="flex items-center gap-2">
                        <FaLightbulb className="text-yellow-500" /> Tips to Avoid Rejection
                     </span>
                  }
                  answer={
                     <ul className="space-y-2">
                        <li className="flex items-start gap-2">
                           <FaRecycle className="text-green-600 mt-1" />
                           <span>Check for the “NY 5¢” label before collecting bottles or cans</span>
                        </li>
                        <li className="flex items-start gap-2">
                           <FaRecycle className="text-green-600 mt-1" />
                           <span>Keep receipts or note store labels that show it was bought in NY</span>
                        </li>
                        <li className="flex items-start gap-2">
                           <FaRecycle className="text-green-600 mt-1" />
                           <span>Contact your local redemption center if you’re unsure</span>
                        </li>
                     </ul>
                  }
               />

            </div>
         </section>

         <section className="bg-[#F6F9F1] py-16 px-6 md:px-20">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-10">

               {/* LEFT CONTENT */}
               <div className="w-full lg:w-2/3">
                  <p className="text-[#9cc026] font-semibold mb-2">CTRV: ME NY</p>

                  <h2 className="text-3xl md:text-4xl font-bold text-[#1a4632] leading-tight mb-6">
                     What Does <span className="text-[#9cc026]">CTRV: ME NY</span> Mean in Recycling?
                  </h2>

                  <p className="text-gray-700 mb-4">The term <strong>“CTRV: ME NY”</strong> found on bottles and cans relates to container deposit labeling for multiple U.S. states — specifically Connecticut (CT), Maine (ME), and New York (NY).
                  </p>

                  <p className="text-gray-700 mb-6"> It indicates that the beverage container may be eligible for redeem credit based on applicable state deposit programs.
                  </p>

                  <ul className="space-y-4 text-gray-700">
                     <li className="flex items-start gap-3">
                        <FaCheckCircle className="text-[#9cc026] mt-1 w-5 h-5 self-start" />
                        <span><strong>CTRV</strong> = “Container Return Value” (another term for bottle deposit value)</span>
                     </li>

                     <li className="flex items-start gap-3">
                        <FaCheckCircle className="text-[#9cc026] mt-1 w-5 h-5 self-start" />
                        <span><strong>ME NY</strong> = The states Maine and New York</span>
                     </li>

                     <li className="flex items-start gap-3">
                        <FaCheckCircle className="text-[#9cc026] mt-1 w-5 h-5 self-start" />
                        <span>This container may carry a deposit value eligible for redeem credit in ME & NY.</span>
                     </li>

                     <li className="flex items-start gap-3">
                        <FaCheckCircle className="text-[#9cc026] mt-1 w-5 h-5 self-start" />
                        <span>Labels like <strong>CT • ME • NY 5¢</strong> show where you can redeem the container.</span>
                     </li>
                  </ul>
               </div>

               {/* RIGHT IMAGE */}
               <div className="w-full lg:w-1/3 flex justify-center">
                  <div className="flex items-center">
                     <img
                        src={recycleIcon}
                        alt="Recycle Symbol"
                        className="object-contain max-h-[280px] w-auto"
                     />
                  </div>
               </div>
            </div>
         </section>

         <section className=" py-16 px-6 md:px-16">
            <div className="max-w-screen-2xl mx-auto">

               <p className="text-[#74AF20] font-semibold text-lg mb-2">How It Works</p>

               <h2 className="text-3xl md:text-4xl font-bold text-[#1a4632] leading-tight mb-6">
                  How to reclaim CTRV:ME NY <span className="text-[#9cc026]">beverage containers through</span> FareFuel?
               </h2>

               <p className="text-[#6C7B76] max-w-xl mb-14">
                  To reclaim your CTRV:ME NY beverage containers through FareFuel, follow the same simple process used for eligible containers under New York’s Bottle Bill:
               </p>

               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

                  {/* Step 1 */}
                  <div className="text-center">
                     <div className="flex justify-center mb-4">
                        <img src={checkmark} alt="Eligibility" className="h-14" />
                     </div>

                     <h3 className="text-xl font-semibold text-[#9cc026] mb-2">Confirm Container Eligibility</h3>

                     <ul className="text-[#6C7B76] text-sm list-disc pl-5 space-y-2 text-justify">
                        <li>Must carry the “NY 5¢” or “CTRV:ME NY” deposit label.</li>
                        <li>Must be glass, plastic, or metal and under 1 gallon.</li>
                        <li>Must be empty, intact, and clean.</li>
                     </ul>
                  </div>

                  {/* Step 2 */}
                  <div className="text-center">
                     <div className="flex justify-center mb-4">
                        <img src={partner} alt="Drop Off" className="h-14" />
                     </div>

                     <h3 className="text-xl font-semibold text-[#9cc026] mb-2">Drop Containers at FareFuel</h3>

                     <ul className="text-[#6C7B76] text-sm list-disc pl-5 space-y-2 text-justify">
                        <li>Visit a FareFuel-affiliated redemption center or partner retailer.</li>
                        <li>Partners accept eligible containers based on brand, size, and type.</li>
                        <li>Note: Daily limits may apply depending on store size.</li>
                     </ul>
                  </div>

                  {/* Step 3 */}
                  <div className="text-center">
                     <div className="flex justify-center mb-4">
                        <img src={credit} alt="Receive Credit" className="h-14" />
                     </div>

                     <h3 className="text-xl font-semibold text-[#9cc026] mb-2">Receive Redeem Credit</h3>

                     <ul className="text-[#6C7B76] text-sm list-disc pl-5 space-y-2 text-justify">
                        <li>Insert containers into a reverse vending machine (RVM) or process at the counter.</li>
                        <li>You will receive a voucher based on eligible container value.</li>
                        <li>Vouchers can be converted into your FareFuel rewards balance.</li>
                     </ul>
                  </div>

                  {/* Step 4 */}
                  <div className="text-center">
                     <div className="flex justify-center mb-4">
                        <img src={redeem} alt="Redeem" className="h-14" />
                     </div>

                     <h3 className="text-xl font-semibold text-[#9cc026] mb-2">Redeem or Use Rewards</h3>

                     <ul className="text-[#6C7B76] text-sm list-disc pl-5 space-y-2 text-justify">
                        <li>Apply your rewards toward supported services available on FareFuel.</li>
                        <li>Use rewards for options like mobile bill payments, fuel-related benefits, or other approved services.</li>
                     </ul>
                  </div>

               </div>

               {/* Bottom Cards */}

               <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                  {/* Card 1 */}
                  <div className="bg-[#ECFFDC] border border-[#25994c] rounded-lg p-6 shadow-sm">
                     <div className="flex items-center gap-2 text-[#1a4632] text-xl mb-4">
                        <HiOutlineInformationCircle />
                        <h4 className="font-semibold text-lg">Important Details & Tips</h4>
                     </div>

                     <ul className="text-sm text-[#6C7B76] space-y-3">
                        <li>✔ Make sure containers are clean and undamaged.</li>
                        <li>✔ For large quantities, contact the center in advance.</li>
                        <li>✔ Only eligible containers with proper labels can be processed.</li>
                     </ul>
                  </div>

                  {/* Card 2 */}
                  <div className="bg-[#ECFFDC] border border-[#25994c] rounded-lg p-6 shadow-sm">
                     <div className="flex items-center gap-2 text-[#1a4632] text-xl mb-4">
                        <TbRecycle />
                        <h4 className="font-semibold text-lg">Why This Works</h4>
                     </div>

                     <p className="text-sm text-[#6C7B76] mb-4">
                        FareFuel operates within approved recycling and redemption systems to ensure eligible containers are processed correctly.
                     </p>

                     <ul className="text-sm text-[#6C7B76] space-y-3">
                        <li>✔ Containers are verified through authorized channels</li>
                        <li>✔ Rewards are issued based on eligible returns</li>
                        <li>✔ Redemption follows applicable local regulations</li>
                     </ul>
                  </div>

                  {/* Card 3 */}
                  <div className="bg-[#ECFFDC] border border-[#25994c] rounded-lg p-6 shadow-sm">
                     <div className="flex items-center gap-2 text-[#1a4632] text-xl mb-4">
                        <RiFileList3Line />
                        <h4 className="font-semibold text-lg">Summary</h4>
                     </div>

                     <ul className="text-sm text-[#6C7B76] space-y-3">
                        <li>✔ Bring eligible containers to a FareFuel partner</li>
                        <li>✔ Process them using RVM or counter</li>
                        <li>✔ Receive rewards in your FareFuel balance</li>
                        <li>✔ Use rewards for supported services</li>
                     </ul>
                  </div>

               </div>

            </div>
         </section>

         <Footer />
      </div>
   );
}

export default Home;

